// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Composite API
 * HTTP API for managing Neo4j composite database instances.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const ModelsCompositeInstanceState = {
  CompositeInstanceStateCreating: 'CREATING',
  CompositeInstanceStateError: 'ERROR',
  CompositeInstanceStateRunning: 'RUNNING',
  CompositeInstanceStateUpdating: 'UPDATING',
  CompositeInstanceStateDeleted: 'DELETED',
} as const;
export type ModelsCompositeInstanceState =
  (typeof ModelsCompositeInstanceState)[keyof typeof ModelsCompositeInstanceState];

export function instanceOfModelsCompositeInstanceState(value: any): boolean {
  for (const key in ModelsCompositeInstanceState) {
    if (
      Object.prototype.hasOwnProperty.call(ModelsCompositeInstanceState, key)
    ) {
      if (
        ModelsCompositeInstanceState[
          key as keyof typeof ModelsCompositeInstanceState
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function ModelsCompositeInstanceStateFromJSON(
  json: any,
): ModelsCompositeInstanceState {
  return ModelsCompositeInstanceStateFromJSONTyped(json, false);
}

export function ModelsCompositeInstanceStateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ModelsCompositeInstanceState {
  return json as ModelsCompositeInstanceState;
}

export function ModelsCompositeInstanceStateToJSON(
  value?: ModelsCompositeInstanceState | null,
): any {
  return value as any;
}

export function ModelsCompositeInstanceStateToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): ModelsCompositeInstanceState {
  return value as ModelsCompositeInstanceState;
}
